export default __webpack_public_path__ + "static/media/tiktok-black.651a897d.svg";